import React, { useEffect, useState } from 'react';

import { BREEDER_APPLICATION_IDS } from 'dpl/join_as_breeder/utils/constants';
import BreederApplicationContainer from 'dpl/join_as_breeder/containers/BreederApplicationContainer';

export default function MobileBreederJoinNavigation() {
  const [displaySection, setDisplaySection] = useState(false);

  useEffect(() => {
    function handleScroll(e) {
      const window = e.currentTarget;
      setDisplaySection(window.scrollY > 10);
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (!displaySection) {
    return null;
  }

  return (
    <div className="MobileBreederJoinNavigation w-100 fixed z-9999 bg-white shadow-1 fw-medium bottom-0 iphone-notch-bottom left-0">
      <div className="MobileBreederJoinNavigation__button w-100 w-auto-l ph3 pv3 center tc">
        <BreederApplicationContainer
          sectionId={BREEDER_APPLICATION_IDS.HEADER}
          className="w-100 w-auto-ns pv3"
          withBadge
        />
      </div>
    </div>
  );
}
